<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Usuarios</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-btn absolute dark fab top right color="success" @click="dialog = true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-card-text>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="datos"
            :items-per-page="5"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-card>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-switch :label="editedItem.active ? 'Activo' : 'Inactivo'" v-model="editedItem.active" color="success" v-if="editedIndex > -1"></v-switch>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field v-model="editedItem.name" label="Nombres" required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="editedItem.email" label="Email" required outlined></v-text-field>
              </v-col>              
              <v-col cols="6">
                <v-text-field v-model="editedItem.user" label="Usuario" required outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select :items="niveles" v-model="editedItem.level" label="Nivel de Usuario" outlined></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-btn color="blue darken-1" text @click="restablecer">Reiniciar Clave</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import swal from "sweetalert";
import api from "../conf/ruta-base";
import store from "../store";
export default {
  name: "usuarios",
  data: () => ({
    apiPath: "users",
    search: "",
    dialog: false,
    headers: [
      { text: "Nombre", align: "start", sortable: true, value: "name" },
      { text: "Usuario", value: "user" },
      { text: "Nivel", value: "level" },
      { text: "Correo", value: "email" },
      { text: "Acciones", value: "actions", sortable: false }
    ],
    datos: [],
    selec: '',
    niveles: [
        {text:'Administrador',value:'admin'},
        {text:'Usuario Standart',value:'user'}, 
        ],
    instituciones:[],
    editedIndex: -1,
    defaultItem: {
      //id: null,
      name: "",
      photo: "",
      active: true,
      user: "",
      level: "user",
      access: {},
      pwd: "",
    },
    editedItem: null
  }),
  created(){
    this.editedItem = Object.assign({}, this.defaultItem);
  },

  mounted() {
    axios
      .get(api.api + this.apiPath)
      .then(r => {
        this.datos = r.data
      })
      .catch(error => {
        console.log(error);
      });
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Usuario" : "Modificar Usuario";
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.datos.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    presave(){
      let bandera = true
      let err = ''
        if(bandera && this.editedItem.name.length == 0){
          bandera = false
          err = 'Debe ingresar el nombre.'
        }

        if(bandera && this.editedItem.user.length == 0){
          bandera = false
          err = 'Debe especificar el nombre de usuario'
        }
  
        if(bandera && this.editedItem.email.length == 0){
          bandera = false
          err = 'Debe ingresar el correo'
        }

        if(bandera && this.editedItem.level.length == 0){
          bandera = false
          err = 'Ingrese el nivel'
        }

      if(bandera){
        this.save()
      }else{
        swal('',err,'error');
      }
      
    },

    save() {
      if (this.editedIndex > -1) {
        let index = this.editedIndex
        Object.assign(this.datos[this.editedIndex], this.editedItem)
        axios
          .patch(api.api + this.apiPath + '/' + this.editedItem.id, this.editedItem)
          .then(res => {
            this.toast('success', 'Usuario Actualizado');
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.editedItem.pwd = this.editedItem.user
        axios
          .post(api.api + this.apiPath, this.editedItem)
          .then(res => {
            this.datos.push(res.data);
            this.toast('success', 'El usuario ha sido creado');
          })
          .catch(error => {
            console.log(error);
          });
      }
      this.close();
    },
    
    deleteItem (item) {
      const index = this.datos.indexOf(item)
      swal({text: "¿Seguro que desea eliminar?",icon: "warning", buttons: ["Cancelar", "Ok"],})
      .then(ok => {
        if(ok){
          axios.delete(api.api + this.apiPath + '/' + item.id)
          .then(res => {
            if(res.status==204){
              this.datos.splice(index, 1)
            }
            this.toast('success', 'Usuario Eliminado');
          })
          .catch(error => {
            console.log(error);
          });
        }
      })
    },
    
    restablecer(){
      axios
          .put(api.api + 'user/reset/' + this.editedItem.id, this.editedItem)
          .then(res => {
            this.toast(res.data.c, res.data.mensaje);
          })
          .catch(error => {
            console.log(error);
          });
      this.close()
    },

    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    }
  }
};
</script>